module.exports = __webpack_public_path__ + "img/Weekdays.36c6cc19.svg";